/**
 * Formatting for challenge figures, shared by the badge and (later) the
 * Challenges admin pages so the two cannot drift.
 *
 * All money is INR with Indian digit grouping (₹4,50,000) — `income_amount` is
 * already INR in the database, so nothing is ever converted. Admission
 * challenges are a count, not an amount.
 */

const inr = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  maximumFractionDigits: 0,
});

const plain = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 });

export const CHALLENGE_TYPE_LABELS = {
  admission: 'Admission',
  sales_revenue: 'Sales revenue',
  fee_collection: 'Fee collection',
  fee_plus_sales_revenue: 'Fee + Sales revenue',
};

export function formatChallengeValue(value, type) {
  const rounded = Math.round(Number(value) || 0);
  return type === 'admission' ? plain.format(rounded) : inr.format(rounded);
}

/** "₹1,20,000 to go", "5 admissions to go", or "Achieved". */
export function formatGap(gap, type) {
  const remaining = Math.round(Number(gap) || 0);
  if (remaining <= 0) return 'Achieved';
  if (type === 'admission') {
    return `${plain.format(remaining)} admission${remaining === 1 ? '' : 's'} to go`;
  }
  return `${inr.format(remaining)} to go`;
}

/** "Updated 3 min ago" — relative to the last successful fetch. */
export function formatUpdatedAt(timestamp) {
  if (!timestamp) return '';
  const seconds = Math.max(0, Math.floor((Date.now() - timestamp) / 1000));
  if (seconds < 45) return 'Updated just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 1) return 'Updated just now';
  if (minutes < 60) return `Updated ${minutes} min ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `Updated ${hours} hr ago`;
  return `Updated ${Math.floor(hours / 24)} d ago`;
}
